import { isEmpty } from 'lodash';

import type { Answer } from '../../../../../api/creatorElements.api';
import { REQUIRED_ANSWER_TYPES } from '../constants';

const normalizeAnswerText = (text: string | null | undefined): string => text?.trim() ?? '';

export const isDuplicateAnswerText = (answers: Answer[], answerText: string | null | undefined): boolean => {
    const normalizedText = normalizeAnswerText(answerText);
    if (normalizedText.length === 0) {
        return false;
    }

    return answers.filter((answer) => normalizeAnswerText(answer.text) === normalizedText).length > 1;
};

const hasDuplicateAnswerTexts = (answers: Answer[]): boolean =>
    answers.some((answer) => isDuplicateAnswerText(answers, answer.text));

export const validateAnswers = ({
    answers,
    minCorrectAnswers,
    requiredAnswerType,
    totalAnswersToDisplay,
}: {
    answers: Answer[];
    minCorrectAnswers: number;
    requiredAnswerType: string;
    totalAnswersToDisplay: number;
}) => {
    const filledAnswers = answers.filter((a) => !isEmpty(a.text));
    const filledCount = filledAnswers.length;

    const hasEnoughAnswers = filledCount >= totalAnswersToDisplay;

    const isCorrectMode =
        requiredAnswerType === REQUIRED_ANSWER_TYPES.CORRECT || requiredAnswerType === REQUIRED_ANSWER_TYPES.RANDOM;

    const correctCount = filledAnswers.filter((a) => (isCorrectMode ? a?.isCorrect : !a?.isCorrect)).length;

    const incorrectCount = filledCount - correctCount;

    const hasDistribution = correctCount >= minCorrectAnswers && incorrectCount >= 1;
    const hasUniqueAnswerTexts = !hasDuplicateAnswerTexts(filledAnswers);

    const areAnswersValid = hasEnoughAnswers && hasDistribution && hasUniqueAnswerTexts;

    return {
        areAnswersValid,
        hasEnoughAnswers,
        hasDistribution,
        hasUniqueAnswerTexts,
        filledCount,
        correctCount,
        incorrectCount,
    };
};
